<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :show-close="true"
    theme="info"
    :showIcon="false"
    width="80%"
    custom-class="tg-confirm-dialog"
    :visible.sync="visible"
    @on-confirm="handleConfirm"
    :showFooter="!isSub && tabIndex == 1"
    :confirmLabel="confirmLabel"
    destroy-on-close
    :disableConfirmBtn="authorized"
  >
    <div v-if="action == 'edit'" class="upper_groups">
      {{ upper_group_names }}
    </div>

    <template v-if="action != 'add' ">
      <el-row type="flex" class="upper_groups" v-if="params.group == 10">
        <tg-button
          round
          border
          hoverBorderOnly
          theme="primary"
          :active-gradient="tabIndex==1"
          @click.native="tabIndex=1"
        >
          {{ $t("component.tab.material.normal")}}
        </tg-button>

        <tg-button
          v-if="enableThirdParty"
          round
          border
          hoverBorderOnly
          theme="primary"
          :active-gradient="tabIndex==2"
          @click.native="tabIndex=2"
          >
            {{ $t("component.tab.material.third_party_wallet")}}
        </tg-button>

        <tg-button
          v-if="mirconetData.is_micronet == 1"
          round
          border
          hoverBorderOnly
          theme="primary"
          :active-gradient="tabIndex==3"
          @click.native="tabIndex=3"
          >
            {{ $t("component.tab.material.micronet")}}
        </tg-button>
      </el-row>
    </template>
    
    <tg-form-table
      v-if="tabIndex==1"
      :columns="columns"
      :data.sync="tableData"
      :fenceRow="fenceRow"
      :fenceCol="fenceCol"
      :columnWidth="250"
      :cellWidth="400"
    >
      <template slot="usernameDropdown">
        <template v-if="general.mode == 1">
          <tg-dropdown
            :items="dropdown.username"
            @on-change="handleUserNameChange"
          ></tg-dropdown>
        </template>
        <template v-else>
          
          <el-input
            :placeholder="$t('component.form.input.placeholder.username_pattern')"
            v-model="tableData.username"
            class="tg-input col-8"
            size="small"
            clearable
          >
          <template v-if="tableData.prefix" slot="prepend">{{tableData.prefix}}</template>
        </el-input>
        </template>
      </template>
      <template slot="userfullname" slot-scope="scope">
        <template v-if="action == 'info'">
          <tg-user-full-name
            :column="scope.column"
            :row="scope.row"
          ></tg-user-full-name>
        </template>
        <template v-else>{{ scope.value }}</template>
        <tg-button
          v-if="!isSub && ((scope.row.group > 10 && $user.permissions[47] > 1) || (scope.row.group == 10 && $user.permissions[41] > 1))"
          class="tg-btn--member-delete"
          round
          @click.native="handleDelete(scope.value)"
          >{{ $t("component.btn.remove") }}</tg-button
        >
      </template>
      <template slot="merchant_name" slot-scope="scope">
        <el-input
          v-if="!isSub && scope.column.enable == true"
          :placeholder="$t('component.form.input.placeholder.merchant_name')"
          v-model="tableData[scope.column.name]"
          class="tg-input col-8"
          size="small"
          clearable
        ></el-input>
        <span v-else>
          <template v-if="!isSub">{{ $t("message.editable.l70_up") }}</template>
        </span>
      </template>
      <template slot="password" slot-scope="scope">
        <el-input
          v-if="!isSub && scope.column.enable == true"
          :placeholder="$t('component.form.input.placeholder.password[1]')"
          v-model="tableData[scope.column.name]"
          class="tg-input col-8"
          size="small"
          type="password"
          clearable
        ></el-input>
        <span v-else>
          <template v-if="!isSub">{{ $t("message.editable.l70_up") }}</template>
        </span>
      </template>

      <template slot="handicapDropdown" slot-scope="scope">
        <tg-dropdown
          v-if="$user.permissions[39] > 1"
          :items="dropdown.handicap_id"
          @on-change="handleHandicapChange"
        ></tg-dropdown>
        <span v-else>
          {{ dropdown.handicap_id[scope.value].label }}
        </span>
      </template>

      <template slot="dangerLevel" slot-scope="scope">
        <template v-if="$user.permissions[55] > 1">
          <tg-dropdown
            :items="dropdown.dangerLevel"
            id="dangerLevel"
            @on-change="handleDangerLevelChange"
          ></tg-dropdown>
          <tg-button
              class="tg-btn--confirm"
              round
              @click.native="updateDangerLevel(dangerLevel == 0 ? 'D' : dangerLevel)"
              >
              {{ $t("btn.apply") }}
            </tg-button>
        </template>
        <template v-else>
          <span :class='{"text-danger": scope.value == "A"}'>
            {{ $t('enum.dangerLevel', {level:  scope.value, num: dangerLevelMap[scope.value]}) }}
          </span>
        </template>
      </template>
      <template slot="edit_members_danger_level">
        <template v-if="$user.permissions[55] > 1" >
          <tg-dropdown
            :items="dropdown.mDangerLevel"
            ref="mDangerLevel"
            id="dangerLevel"
            @on-change="handleDangerLevelChange"
          ></tg-dropdown>
          <tg-button
              class="tg-btn--confirm"
              round
              @click.native="updateDangerLevel(dangerLevel, true)"
              >
              {{ $t("btn.apply") }}
            </tg-button>
        </template>
      </template>
      <template slot="user_color" slot-scope="scope">
        <el-input  type="color" :value="scope.value" style="width: 100px;height: 20px;" disabled></el-input>
      </template>

      <template slot="text_input" slot-scope="scope">
        <el-input
          v-if="!isSub && scope.column.enable == true"
          v-model="tableData[scope.column.name]"
          class="tg-input col-8"
          size="small"
          type="text"
          clearable
        ></el-input>
        <span v-else>{{ scope.value }}</span>
      </template>
      <template slot="blocked" slot-scope="scope">
        <template
          v-if="
            isSub ||
            ('editable' in scope.column && scope.column.editable == false)
          "
          >{{
            $t("enum." + scope.column.name + "[" + scope.value + "]")
          }}
        </template>
        <template v-else>
          <tg-dropdown
            :items="dropdown[scope.column.name]"
            trigger="click"
            @on-change="handleBlockedChange($event, scope.column.name)"
          ></tg-dropdown>
        </template>
      </template>
      <template slot="percent" slot-scope="scope">
        <el-row type="flex" justify="center" align="middle">
          <template v-if="!isSub && ((scope.column.name == 'breakwater' && $user.permissions[43] > 1) || (scope.column.name != 'breakwater' && $user.permissions[42] > 1))">
            <el-input
              v-model="tableData[scope.column.name]"
              class="tg-input hasUnit"
              :class='{"blinking-input": ("third_party" in scope.column && SyncPercent)}'
              size="small"
              type="number"
              style="width: 90px"
              :max="scope.row[scope.column.name + 'Limit']"
              
            >
            <template slot="append">%</template>
            </el-input>
            <span style="line-height: 32px"
              >
              <template v-if="$store.state.service.merchantCode != 'AA008'">
                ({{
                  $t("page.member.info." + (scope.column.name == 'breakwater' ? 'breakwaterLimit' : "percentLimit"), {
                    value: scope.row[scope.column.name + "Limit"],
                  })
                }}%)
              </template>
            </span>
          </template>
          <template v-else>{{ tableData[scope.column.name] }}%</template>
        </el-row>
      </template>

      <template slot="thirdPartyPercent" slot-scope="scope">
        <el-row type="flex" justify="center" align="middle">
          <template>{{ tableData[scope.column.name] }}%</template>
        </el-row>
      </template>

      <template slot="relativeTime" slot-scope="scope">
        <tg-relative-time v-bind="scope"></tg-relative-time>
      </template>

      <template slot="identityVerified" slot-scope="scope">
        <span>{{ $t('enum.identityVerified[' + (scope.row[scope.column.name] || 0)+ ']') }}</span>
      </template>

      <!-- 風控裝置懲處 -->
      <template slot="device_risk_status" slot-scope="scope">
        <template v-if="scope.row.riskControlInfo.punishCount ===  '0'">
          <span>{{ $t("enum.none") }}</span>
        </template>
        <template v-else >
          <span>{{ $t("label.punished") }}</span>
          <!-- <tg-button
            v-if="!isSub && ($user.permissions[13] > 1)"
            class="tg-btn--member-delete"
            round
            @click.native="handleRemovePunish(scope.row.username)"
            >{{ $t("component.btn.unlock") }}</tg-button
          > -->
        </template>
      </template>
      <template slot="device_risk_punish" slot-scope="scope">
        <template v-if="scope.row.riskControlInfo.punishCount > 0">
          <span>{{ scope.row.riskControlInfo.punishFrom }}</span> ~ <span>{{ scope.row.riskControlInfo.punishTo }}</span>
        </template>
      </template>

      <template slot="header.percent" slot-scope="{column}">
        <el-row type="flex" justify="center" align="middle" class="py-3 is-vertical">
         <span>
          {{
            column.langKey
              ? $t("column." + column.langKey, { third_party:  $t("column."+column.third_party) })
              : column.title
          }}
         </span>
         <tg-button
            class="tg-btn--confirm"
            round
            @click.native="syncToThirdPartyPercent(tableData[column.name])"
            >
            {{ $t("btn.apply_click") }}
          </tg-button>
        </el-row>
        
      </template>
    </tg-form-table>

    <el-row
      type="flex"
      class="col-12 is-vertical"
      :class='{"pa-8": loading == 2, "pa-2": loading == 0}'
      v-if="tabIndex==2"
      v-loading="loading == 2"
      element-loading-text="loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
    >
      <template v-for="(thirdPartys, category) in thirdPartyWallets">
          <el-row type="flex" :key="'category-' + category" class="col-12 ma-3">
            <el-col :span="24" class="wallet-category">{{ $t("enum.source_type[" + category + "]")}}</el-col>  
          </el-row>
          <el-row type="flex" :key="category" class="wallet-platforms">            
            <template v-for="(thirdParty, i) in thirdPartys">
              <el-col :span="8" :key="'thirdParty-' + i" class="wallet-platforms--platform">
                <span class="col-5">{{ $t('column.' + thirdParty.platform)}}</span>
                
                <span class="col-7">
                  <template v-if="thirdParty.isRegister">
                    {{ thirdParty.balance == -1 ? '--.--' : thirdParty.balance }}
                  </template>
                  <template v-else>
                    {{ $t('component.label.unregister')}}
                  </template>
                </span>
              </el-col>
            </template>
          </el-row>
      </template>
    </el-row>

    <tg-form-table
      v-if="tabIndex==3"
      :columns="micronetColumns"
      :data.sync="mirconetData"
      :fenceRow="fenceRow"
      :fenceCol="fenceCol"
      :columnWidth="250"
      :cellWidth="400"
    >
    <template slot="member_type" slot-scope="scope">
      <template v-if="scope.row.member_type == 1">
        <span>{{ $t('enum.active[1]') }}</span>
      </template>
      <template v-else-if="scope.row.member_type == 2">
        <span>{{ $t('enum.active[0]') }}</span>
      </template>
      <template v-else>
        <span>{{ $t('component.label.not_tg_business_member') }}</span>
      </template>
    </template>
    </tg-form-table>
    <tg-dialog
      theme="warning"
      width="20%"
      :visible.sync="visibleDeleteDialog"
      :show-close="true"
      :subject="subject"
      showFooter
      append-to-body
      showCancelBtn
      @on-confirm="handleConfirmDelete"
    >
      <template slot="subject">
        <span>{{ subject }}</span>
        <span class="text-primary">{{ deleteName }}</span>
      </template>
    </tg-dialog>

    <tg-freeze-dialog
      ref="freezeDialog"
    ></tg-freeze-dialog>
  </tg-dialog>
</template>

<script>
import TgDialog from "@/components/dialog/TgDialog";
import TgFormTable from "@/components/table/TgFormTable";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgRelativeTime from "@/components/slot/TgRelativeTime";
import TgButton from "@/components/button/TgButton";
import TgFreezeDialog from "@/components/dialog/TgFreezeDialog";

// import formatter from "@/utils/formatter";
import apis from "@/apis";

import validator from "@/mixins/validator";
import str from "@/utils/str";

export default {
  mixins: [validator],
  inheritAttrs: false,
  components: {
    TgDialog,
    TgFormTable,
    TgDropdown,
    TgUserFullName,
    TgRelativeTime,
    TgButton,
    TgFreezeDialog
  },
  data() {
    return {
      columns: [],
      tableData: {},
      dropdown: {},
      visible: false,
      request: {},
      visibleDeleteDialog: false,
      deleteName: "",
      authorized:null,
      tabIndex: 1,
      loading: 2,
      thirdPartyWallets: {},
      general: {
        mode: 1,
        regex: ''
      },
      micronetColumns: [],
      mirconetData: {},
      SyncPercent: false,
      dangerLevel: 0,
      dangerLevelMap: {},
    };
  },
  props: {
    dataProxy: Function,
    confirmProxy: Function,
    params: Object,
  },
  computed: {
    fenceRow() {
      if (this.action == "edit") {
        return this.params.group == 10 ? 7 : 5;
      } else {
        return 4;
      }
    },
    fenceCol() {
      return 2;
    },
    confirmLabel() {
      return this.params.confirmLabel;
    },
    action() {
      return this.params.action;
    },
    subject() {
      return this.$t("message.warning.deleteMember");
    },
    upper_group_names() {
      let txts = [];

      [80, 70, 60, 40, 20].forEach((group) => {
        if (group > this.$user.group || group <= this.tableData.group) {
          return false;
        }
        txts.push(
          str.format(
            "{0}({1})",
            this.$t("column.l" + group),
            this.tableData["l" + group]
          )
        );
      });

      return txts.join(" > ");
    },
    enableThirdParty() {
      return this.$store.state.app.enableThirdParty;
    },
  },
  methods: {
    showDialog() {
      this.loading = 2;
      this.tabIndex = 1;

      this.dataProxy(this.params).then((response) => {
        this.authorized = response.data.authorized;
        this.columns = response.columns;
        this.tableData = this.parseData(response.data, response.columns);
        let dropdown = this.parseDropdown(response.dropdown, response.data);
        this.dangerLevelMap = response.dropdown.dangerLevel ?? {};

        if (this.params.action == "add") {
          if (response.general.mode == 1) {
            this.tableData.username = dropdown.username[0].value;
          }
          this.general = response.general;
        }
        this.dropdown = dropdown;
        this.tableData.motherusername = this.params.username;
        this.micronetColumns = response.micronetColumns;
        this.mirconetData = response.data.micronet;

        this.$nextTick(() => {
          this.visible = true;
        });
      });
      if (this.params.action != "add") {
        if (this.params.group == 10 && this.enableThirdParty) {
          apis.member.profile.getThirdPartyWallet({...this.params, action: 'thirdPartyWallet'}).then(response => {
            this.thirdPartyWallets = response.data;
            this.loading = 0;
          });
        }
      }
    },
    parseData(data) {
      // 為不存在handicap_id的會員設定預設值(1)
      if(data.handicap_id === null) {
        data.handicap_id = 1;
      }

      return data;
    },
    parseDropdown(dropdown, data) {
      let d = {};
      for (let k in dropdown) {
        d[k] = [];
        if (k == 'dangerLevel') {
          d['mDangerLevel'] = [
              {
                label: this.$t("component.dropdown.default"),
                value: 0,
                active: true,
              }
            ];
          Object.keys(dropdown[k]).forEach((item) => {
            let val = dropdown[k][item];

            let i = {
              label: this.$t('enum.dangerLevel', {level: item, num: val}),
              value: item,
              active: data["danger_level"] == item,
              class: item == 'A' ? 'text-danger' : ''
            };

            d[k].push(i);
            d['mDangerLevel'].push(i);
          });
        } else if (k == 'handicap_id') {
          dropdown[k].forEach((item) => {
            d[k].push({
              label: item.rate == '0.00' ? this.$t('enum.handicap_id[' + item.id + ']') : item.name + '-' + item.rate + '%',
              value: item.id,
              active: data[k] == item.id,
            });
          });
        } else {
          dropdown[k].forEach((item) => {
            let langKey = "enum." + k + "[" + item + "]";
            let label = k == "username" ? item : this.$t(langKey);
              d[k].push({
                label: label,
                value: item,
                active: data[k] == item,
                disabled: data['member_block'] == '3' && k == 'loginblocked',
              });
          });
        }
      }
      return d;
    },
    handleConfirm(e) {
      if (
        this.action == "add" &&
        !this.validatePassword(this.tableData.password) &&
        // 自行輸入帳號，且驗證未通過
        (this.general.mode == 0 && !this.validateUsername(this.tableData.username, this.general.regex))
      ) {
        e.preventDefault = true;
        return;
      }

      if (
        this.tableData.password &&
        !this.validatePasswordChange(
          this.tableData.password,
          this.tableData.repassword
        )
      ) {
        e.preventDefault = true;
        return;
      }

      this.confirmProxy(this.tableData)
        .then((response) => {
          if(response.retcode == 0){
            this.$message.success(this.$t("message.success.update"));
            this.$emit("on-success");
          }else{
            let data = response.data;
            if( response.retcode == 208){//凍結帳號
              this.$refs.freezeDialog.show();
            }else if(data['platform']){
              this.$message.error(this.$t("component.label.source_type."+data['platform']) + "," + this.$t("statusCode["+response.retcode+"]",{username: response.username}));
            }else{
              this.$message.error(this.$t("statusCode["+response.retcode+"]",{username: response.username}));
            }
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.visible = true;
          }, 3000);
        });
      // this.$emit("on-confirm", this.tableData);
    },
    handleUserNameChange(item) {
      this.tableData.username = item.value;
    },
    handleBlockedChange(item, columnName) {
      this.tableData[columnName] = item.value;
    },
    handleDelete(target) {
      this.visibleDeleteDialog = true;
      this.visible = false;
      this.deleteName = target;
    },
    
    handleConfirmDelete() {
      apis.member.action
        .delete({ targetName: this.deleteName })
        .then((response) => {
          if(response["retcode"] == 0){
            this.$message.success(this.$t("message.success.delete"));
            this.$emit("on-success");
          }else{
            var msgBox = "";
            response["data"].forEach((item) => {
              msgBox += this.$t("statusCode["+item+"]")+" ";
            });
            this.$message.error(this.$t("statusCode["+response.retcode+"]",{msgBox: msgBox}));
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.visible = true;
          }, 1500);
        });
    },
    handleHandicapChange(item) {
      this.tableData.handicap_id = item.value;
    },
    handleDangerLevelChange(item) {
      this.dangerLevel = item.value;
    },
    handleRemovePunish(username)
    {
      this.visible = false;

      apis.member.action
        .removePunish({ targetName: username })
        .then((response) => {
          
          if(response["retcode"] == 0){
            this.$message.success(this.$t("message.success.update"));
            this.$emit("on-success");
          }else{
            this.$message.error(this.$t("message.error.failure_try_again"));
          }

          this.showDialog();
        })
        .catch(() => {
          setTimeout(() => {
            this.visible = true;
          }, 1500);
        });
    },
    syncToThirdPartyPercent(percent)
    {
      this.columns.forEach(col => {
        if ('third_party' in col) {
          let k = col.third_party + '_percent';
  
          this.tableData[k] = percent;
        }
      });

      this.SyncPercent = true;

      setTimeout(() => {
        this.SyncPercent = false;
      }, 2500);
    },
    updateDangerLevel(dangerLevel, batch = false)
    {
      if (dangerLevel === 0) return;

      let params = {batch, username: this.tableData.username, value: dangerLevel};

      apis.member.updateMaterial.dangerLevel(params)
        .then((response) => {
          if (response.retcode == 0) {
            this.$message.success(this.$t("message.success.update"));
            this.$emit("on-success");
          } else {
            this.$refs.mDangerLevel.selectItem(this.tableData.danger_level);
            this.$message.error(this.$t("message.error.failure_try_again"));
          }

          if (batch == true) {
            this.$refs.mDangerLevel.selectItem(0);
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.visible = true;
          }, 1500);
        });
    }
  },
};
</script>
